import React from "react"

const SeminarTypes = ({ types }) => {
  const free = types.includes("無料") ? <div className="dayicon free">無料</div> : ""
  const paid = types.includes("有料") ? <div className="dayicon paid">有料</div> : ""
  const online = types.includes("オンライン") ? <div className="dayicon online">オンライン</div> : ""
  const webinar = types.includes("ウェビナー") ? <div className="dayicon webinar">ウェビナー</div> : ""
  const multi = types.includes("複数日開催") ? <div className="dayicon multi">複数日開催</div> : ""
  const single = types.includes("単日開催") ? <div className="dayicon single">単日開催</div> : ""

  return (
    <>
      {free}
      {paid}
      {online}
      {webinar}
      {multi}
      {single}
    </>
  )
}

export default SeminarTypes
